import { render, staticRenderFns } from "./cityhome.vue?vue&type=template&id=8c37aaec&scoped=true"
import script from "./cityhome.vue?vue&type=script&lang=js"
export * from "./cityhome.vue?vue&type=script&lang=js"
import style0 from "./cityhome.vue?vue&type=style&index=0&id=8c37aaec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c37aaec",
  null
  
)

export default component.exports